import { useBottomTabBarHeight } from "@react-navigation/bottom-tabs";
import { View } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";

export const FooterSpacer = () => {
    const footerHeight = useBottomTabBarHeight();
    const insets = useSafeAreaInsets();

    return (
        <View
            style={{
                height: Math.max(0, footerHeight - insets.bottom),
            }}
        />
    );
};
